import React from 'react';
import PropertyCard from '../PropertyCard';


interface PropertyDashboardListProps {
  data?: any[];
}

const AssignedPropertiesDashboardList: React.FC<PropertyDashboardListProps> = ({ data }) => {
  
  return (
    <div className="property-listing-container">
      <h2 className="section-title">Assigned Properties</h2>

      <div className="properties-grid">
        {data?.map((property, index) => (
          <PropertyCard
            key={index}
            title={property?.name}
            address={property?.address}
            city={property?.city}
            state={property?.state}
            zipcode={property?.zipcode}
            type={property?.category?.name}
            duration={property?.track_hours?.spouse}
          />
        ))}
      </div>
    </div>
  );
};

export default AssignedPropertiesDashboardList;